<div class="back-layer" [@slideInOut]></div>

<div class="email-form-component" [@slideInOut]>
  <div class="header-wrap">
    <div class="head-details">
      <h1>
        <span>Upload File</span>
      </h1>
    </div>
    <div class="close" (click)="close()"><span>esc</span><i class="material-icons">clear</i></div>
  </div>

  <div class="content-wrap">
    <div class="loader-wrap" *ngIf="!fileForm">
      <mat-spinner [diameter]="100"></mat-spinner>
    </div>

    <form *ngIf="fileForm" [formGroup]="fileForm" autocomplete>
      <div class="form-field">
        <label>Loader</label>

        <mat-form-field>
          <mat-select placeholder="Loader" [compareWith]="compareFn" [formControl]="fileForm.controls['loader']">
            <mat-option>
              <ngx-mat-select-search
                [placeholderLabel]="'Loader'"
                [noEntriesFoundLabel]="'No matching loader found'"
                [formControl]="filterLoader"
              ></ngx-mat-select-search>
            </mat-option>

            <mat-option *ngFor="let mine of filteredMines$ | async" [value]="mine">
              {{ mine.site.name }}
            </mat-option>
          </mat-select>
          <mat-error *ngIf="fileForm.controls['loader'].hasError('required')">
            Input is required
          </mat-error>
        </mat-form-field>
      </div>

      <div class="w-full">
        <input
          class="w-full"
          type="file"
          placeholder="Upload File"
          (change)="fileChanged($event.target.files)"
          accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
        />
      </div>
    </form>

    <div class="button-wrap">
      <button
        *ngIf="fileForm"
        mat-flat-button
        color="primary"
        [disabled]="!fileForm.controls['uploadFile'].valid || !fileForm.controls['loader'].valid"
        (click)="onSubmit($event)"
      >
        <span>Upload</span>
      </button>
    </div>
  </div>
</div>
